import { combineReducers } from "@reduxjs/toolkit";
import campaignReducer from "./campaignSlice";
import allCampaingReducer from "./allCampaignSlice";
import userReducer from "./userSlice";
import accountReducer from "./accountSlice";
import templateReducer from "./templateSlice";
import workflowReducer from "./workflowSlice";
import audienceReducer from "./audienceSlice";
import salesReducer from "./salesSlice";
import eventandsignalReducer from "./eventandsignalSlice";
import companyUserReducer from "./companyUserSlice";
import settingsReducer from "./settingsSlice";
import roleSlice from "./roleSlice";
import menuSlice from "./menuSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer } from 'redux-persist'


const authPersistConfig = {
  key: 'auth',
  storage: storage,
}

const rootReducer = combineReducers({
  menuSlice:menuSlice,
  roleSlice :roleSlice,
  campaignSetter: campaignReducer,
  allCampaignSetter: allCampaingReducer,
  accountSetter: accountReducer,
  templateSetter: templateReducer,
  workflowSetter: workflowReducer,
  audienceSetter: audienceReducer,
  eventandsignalSetter: eventandsignalReducer,
  companyUserSetter: companyUserReducer,
  salesSetter: salesReducer,
  settingsSetter: settingsReducer,
  userSetter: persistReducer(authPersistConfig, userReducer),
});


export default rootReducer;
